import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MdLocationOn, MdEmail, MdPhone } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Footer.css";

const FooterComponent = () => {
  const navigate = useNavigate();
  const [copiedNumber, setCopiedNumber] = useState(null);

  const handleNavigation = (idOrPath) => {
    const section = document.getElementById(idOrPath);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/${idOrPath}`);
    }
  };

  const copyToClipboard = async (text, id) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopiedNumber(id);
      setTimeout(() => setCopiedNumber(null), 2000);
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  const services = [
    "Kitchen Renovation",
    "Washroom Renovation",
    "Flooring & Stains",
    "Basement Renovations",
    "Painting",
    "Demolitions",
    "Plumbing",
    "Electrical",
  ];

  return (
    <footer className="footer-section">
      <div className="footer-upper py-5">
        <Container>
          <Row className="gy-4 align-items-start">
            {/* ========= LOGO ========= */}
            <Col lg={3} md={6} sm={12}>
              <div
                className="footer-logo mb-3 d-flex align-items-center gap-2 clickable"
                onClick={() => handleNavigation("home")}
              >
                <img src={logo} alt="Ontario Home Renovations" className="logo-img" />
                <h4 className="company-name">Ontario Home Renovations</h4>
              </div>
              <p className="text-muted">
                Exceptional home renovation services creating beautiful,
                functional, and modern living spaces.
              </p>
            </Col>

            {/* ========= SERVICES ========= */}
            <Col lg={3} md={6} sm={12}>
              <h5 className="footer-title">Core Services</h5>
              <ul className="footer-list">
                {services.map((service, index) => (
                  <li key={index} className="clickable" onClick={() => handleNavigation("services")}>
                    {service}
                  </li>
                ))}
              </ul>
            </Col>

            {/* ========= LINKS ========= */}
            <Col lg={3} md={6} sm={12}>
              <h5 className="footer-title">Navigation Links</h5>
              <ul className="footer-list">
                <li className="clickable" onClick={() => handleNavigation("about")}>About Us</li>
                <li className="clickable" onClick={() => handleNavigation("process")}>Our Process</li>
                <li className="clickable" onClick={() => handleNavigation("contact")}>Contact Us</li>

                {/* === New Gallery Link === */}
                <li className="clickable">
                  <a
                    href="https://vsco.co/ontario-home-renovations/gallery"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-reset"
                  >
                    Gallery
                  </a>
                </li>
              </ul>
            </Col>

            {/* ========= CONTACT ========= */}
            <Col lg={3} md={6} sm={12}>
              <h5 className="footer-title">Connect with Us</h5>
              <div className="footer-contact mt-3">
                <p>
                  <MdLocationOn color="#0D3B66" size={20} className="me-2" />
                  <a
                    href="https://www.google.com/maps/dir/?api=1&destination=55+Town+Center+Court+Unit+%23700,+Toronto,+ON+M1P+4X4"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="map-link"
                  >
                    55 Town Center Court Unit #700, Toronto, ON M1P 4X4
                  </a>
                </p>

                <p>
                  <MdEmail color="#0D3B66" size={20} className="me-2" />
                  <a href="mailto:onhomereno@gmail.com" className="email-link">
                    onhomereno@gmail.com
                  </a>
                </p>

                {/* ==== PHONE NUMBERS ==== */}
                <div className="phone-wrapper">
                  <p className="position-relative">
                    <MdPhone color="#0D3B66" size={20} className="me-2" />
                    <span
                      className="phone-link"
                      onClick={() => copyToClipboard("416 818 6865", "num1")}
                    >
                      416 818 6865
                      {copiedNumber === "num1" && <span className="copy-tooltip">Copied!</span>}
                    </span>
                  </p>
                  <p className="position-relative">
                    <MdPhone color="#0D3B66" size={20} className="me-2" />
                    <span
                      className="phone-link"
                      onClick={() => copyToClipboard("437 236 6214", "num2")}
                    >
                      437 236 6214
                      {copiedNumber === "num2" && <span className="copy-tooltip">Copied!</span>}
                    </span>
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <hr className="footer-divider" />

      <div className="footer-lower py-3 text-center">
        <Container>
          <p className="mb-0 text-white">
            © {new Date().getFullYear()} Ontario Home Renovations. All Rights Reserved. Your partner in beautiful homes.
          </p>
        </Container>
      </div>
    </footer>
  );
};

export default FooterComponent;